import { CopyButton, Tooltip } from '@hkdevs/design-system';
import { useLocation } from '@tanstack/react-router';
import { withoutViewAs } from '../../shell/viewAs';
import { stringifySearch } from '../../urlDates';
import type { LineItemSearchParams } from './LineItemSearchView';

/** What a copied link does: it carries the filters, never whose line items (A16). */
export const COPY_LINK_HINT = 'Opens with these filters for whoever has access';

/**
 * The absolute URL of a search's filters, to share: this page's path (without an admin's
 * /view-as/ prefix, which means nothing to whoever opens it) and the filters as the URL
 * keeps them, without the page, so the link opens on page 1.
 */
export function searchLink(origin: string, pathname: string, search: LineItemSearchParams) {
  const { page: _page, ...filters } = search;
  return `${origin}${withoutViewAs(pathname)}${stringifySearch(filters)}`;
}

/**
 * The page header's Copy link (pc-0ev.8), beside Export PDF. The opener's own access
 * applies: the server scopes the search to them, so a link never widens it.
 */
export function CopySearchLink({ search }: { search: LineItemSearchParams }) {
  const pathname = useLocation({ select: (location) => location.pathname });
  return (
    <Tooltip content={COPY_LINK_HINT}>
      <CopyButton
        size="md"
        value={searchLink(window.location.origin, pathname, search)}
        label="Copy link"
        copiedLabel="Link copied"
      />
    </Tooltip>
  );
}
